// 30x30 circular badge footprint — legacy-map parity (`bg-slate-700 p-1`):
// dark circle, 4px padding, white glyph, no ring or shadow. Hover lift is
// pure CSS so it survives the static-HTML render path. Transform values
// mirror the legacy mouseover handlers exactly: rest at
// `scale(1) translateY(4px)`, hover at `scale(40/30) translateY(-4px)`,
// over a 300ms ease-in-out transition.
.root {
  align-items: center;
  border-radius: 50%;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: flex;
  height: 30px;
  justify-content: center;
  padding: 4px;
  transform: scale(1) translateY(4px);
  transition: transform 300ms ease-in-out;
  width: 30px;

  &:hover {
    transform: scale(1.3333) translateY(-4px);
  }
}

// A marker singled out (hovered on the map, or its list row hovered): larger,
// lifted, with a pulsing ring so the eye finds it among the others.
.root-is-highlighted {
  box-shadow:
    0 0 0 3px #fff,
    0 6px 14px rgb(0 0 0 / 35%);
  transform: scale(1.5) translateY(-6px);
  animation: marker-pulse 1.2s ease-out infinite;

  &:hover {
    transform: scale(1.5) translateY(-6px);
  }
}

@keyframes marker-pulse {
  0% {
    box-shadow:
      0 0 0 3px #fff,
      0 0 0 3px rgb(122 118 110 / 55%),
      0 6px 14px rgb(0 0 0 / 35%);
  }

  100% {
    box-shadow:
      0 0 0 3px #fff,
      0 0 0 14px rgb(122 118 110 / 0%),
      0 6px 14px rgb(0 0 0 / 35%);
  }
}
